import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { settingsApi } from '@/entities/Settings';

import { useShowNotifaction } from '@/shared/hooks/useShowNotifaction.tsx';
import { useSettingsStore } from '@/shared/store/settings.store.ts';

enum KEYS {
	PERSON_SETTINGS = 'PersonSettings',
}

const settingsStore = useSettingsStore.getState();

export const useCreatePersonSettings = () => {
	const personSettings = useMutation({
		mutationFn: settingsApi.createPersonSettings,
		onSuccess: (response) => {
			settingsStore.setSettingsId(response?.id);
			useShowNotifaction({ text: 'Настройки сохранены', type: 'success' });
		},
		onError: (error) => {
			useShowNotifaction({ text: 'Не удалось сохранить настройки', type: 'error' });
		},
	});

	return {
		createSettings: personSettings.mutate,
		isCreatingSettings: personSettings.isPending,
		isCreatingSettingsError: personSettings.isError,
	};
};

export const useGetPersonSettingsById = (personId?: number) => {
	const personSettings = useQuery({
		queryKey: [KEYS.PERSON_SETTINGS, personId],
		queryFn: () => settingsApi.getPersonSettingsById(String(personId)),
		enabled: !!personId,
	});

	return {
		personSettings: personSettings.data,
		isLoadingPersonSettings: personSettings.isLoading,
		isLoadingPersonSettingsError: personSettings.isError,
	};
};

export const useUpdatePersonSettings = () => {
	const queryClient = useQueryClient();
	const personSettings = useMutation({
		mutationFn: settingsApi.updatePersonSettingsById,
		onSuccess: () => {
			useShowNotifaction({ text: 'Настройки обновлены', type: 'success' });
			queryClient.invalidateQueries({ queryKey: [KEYS.PERSON_SETTINGS] });
		},
		onError: (error) => {
			useShowNotifaction({ text: 'Не удалось обновить настройки', type: 'error' });
		},
	});

	return {
		updateSettings: personSettings.mutate,
		isUpdatingSettings: personSettings.isPending,
		isUpdatingSettingsError: personSettings.isError,
	};
};
